export const BUTTON_BOLD = 'bold';
export const BUTTON_ITALIC = 'italic';
export const BUTTON_TITLE = 'header-one';
export const BUTTON_SUBTITLE = 'header-two';
export const BUTTON_NUMBERING = 'ordered-list-item';
export const BUTTON_BULLETS = 'unordered-list-item';
export const BUTTON_BLOCKQUOTE = 'blockquote';
export const BUTTON_CODE_BLOCK = 'code-block';
export const BUTTON_LINK = 'link';

export const BUTTON_ALIGN_LEFT = 'left';
export const BUTTON_ALIGN_RIGHT = 'right';
export const BUTTON_ALIGN_CENTER = 'center';
export const BUTTON_ALIGN_JUSTIFY = 'justify';

export const BUTTON_HEADER_DROPDOWN = 'header-dropdown';
export const BUTTON_LIST_DROPDOWN = 'list-dropdown';
export const BUTTON_ALIGN_TEXT_DROPDOWN = 'align-text-dropdown';

export const BUTTON_IMAGE = 'image';
export const BUTTON_IMAGE_MEDIA_DIALOG = 'imageMediaDialog';
export const BUTTON_VIDEO = 'video';



// WEBPACK FOOTER //
// ./app/components/text-editor/constants/buttons.js